//list of available filter keys

const filterKeyFinancialHeader = {
  START_DATE: "start_date",
  END_DATE: "end_date",
};

export { filterKeyFinancialHeader };
